export default __webpack_public_path__ + "static/media/PRA_Walk_step2.87469f8b.wav";